import PropTypes from 'prop-types'

import SelectField from '../FormLegacy/FormFieldsV2/SelectField'
import Pagination from '../Pagination/Pagination'

const PaginationFooter = ({
  showOnPage,
  pageNumber,
  paginationItemsCount,
  setSiteLoading,
  setShowOnPage,
  setPageNumber,
}) => {
  const countOfAllPaginationBlocks = paginationItemsCount
    ? Math.ceil(paginationItemsCount / showOnPage)
    : 0

  return (
    <div className="ctp-pagination-footer">
      <Pagination
        pageNumber={pageNumber}
        countOfAllPaginationBlocks={countOfAllPaginationBlocks}
        setPageNumber={setPageNumber}
        setSiteLoading={setSiteLoading}
      />
      <SelectField
        name="ShowOnPage"
        value={showOnPage}
        options={[
          { value: 200, label: 'Rows 200' },
          { value: 100, label: 'Rows 100' },
          { value: 50, label: 'Rows 50' },
          { value: 25, label: 'Rows 25' },
        ]}
        onChange={(e) => setShowOnPage(e.target.value)}
      />
    </div>
  )
}

PaginationFooter.propTypes = {
  showOnPage: PropTypes.number,
  pageNumber: PropTypes.number,
  paginationItemsCount: PropTypes.number,
  setSiteLoading: PropTypes.func,
  setShowOnPage: PropTypes.func,
  setPageNumber: PropTypes.func,
}

export default PaginationFooter
